<template>

    <div class="rule-group">
        <v-select class="w-200" size="sm" :model="op" @input="op = $event">
            <option value="and">All rules must match...</option>
            <option value="or">Any rule can match...</option>
        </v-select>
        <draggable v-model="sorted" :group="group.id" handle=".handle" @start="drag=true" @end="drag=false" @update="sortRules">
            <div v-for="(rule, index) in sorted" :key="rule.id" class="mt-10">
                <v-rule
                    :rule="rule"
                    :is-first="index === 0"
                    :is-last="index === sorted.length - 1"
                    :can-remove="sorted.length > min"
                    @add="addRule"
                    @remove="removeRule">
                </v-rule>
            </div>
        </draggable>
    </div>

</template>

<style scoped lang="scss">

    .rule-group {
        border: 1px solid $color-rule;
        border-radius: 3px;
        margin-top: 10px;
        padding: 10px;
        &:first-child {
            margin: 0;
        }
    }

</style>

<script>

import draggable from 'vuedraggable'
import Rule from './Rule';

export default {

    components: {
        draggable,
        'v-rule': Rule,
    },

    props: {
        group: {
            type: Object,
            required: true,
        },
        min: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            op: this.group.op,
            sorted: this.group.rules,
        }
    },

    watch: {

        op(val) {
            this.$store.commit('segmenter/updateRuleGroup', {
                id: this.group.id,
                op: val,
            });
        },

    },

    methods: {

        addRule() {
            this.$store.commit('segmenter/addRule', this.group.id);
        },

        removeRule(id) {
            if (this.sorted.length > this.min) {
                this.$store.commit('segmenter/removeRule', id);
            }
        },

        sortRules() {
            this.$store.commit('segmenter/sortRules', {
                id: this.group.id,
                rules: this.sorted,
            });
        },

    },

}

</script>
